export const fmtFcfa = (n) => `${new Intl.NumberFormat("fr-FR").format(Number(n) || 0)} FCFA`;
export const fmtKm = (n) => `${new Intl.NumberFormat("fr-FR").format(Number(n) || 0)} km`;

export const priceLabel = (v, tv) => {
  if (v.kind === "part_wanted") return tv.kind.part_wanted;
  if (v.kind === "rent") return v.rent_price ? `${fmtFcfa(v.rent_price)} ${tv.perDay}` : tv.onRequest;
  return v.price && !v.price_on_request ? fmtFcfa(v.price) : tv.onRequest;
};

export const waLink = (settings, text) => {
  const n = String(settings.whatsapp || settings.phone || "").replace(/\D/g, "");
  return n ? `https://wa.me/${n}?text=${encodeURIComponent(text)}` : "";
};

export const vehicleTexts = (settings, tv) => {
  const c = settings.vehicles_content || {};
  const pick = (k, fb) => (c[k] || "").trim() || fb;
  return {
    overline: pick("overline", tv.overline), title: pick("title", tv.title), accent: pick("accent", tv.accent), sub: pick("sub", tv.sub), empty: pick("empty", tv.empty),
    interestTitle: pick("interest_title", tv.interestTitle), interestSub: pick("interest_sub", tv.interestSub),
    homeTitle: pick("home_title", tv.homeTitle), homeAccent: pick("home_accent", tv.homeAccent),
    sellOverline: pick("sell_overline", tv.sell.overline), sellTitle: pick("sell_title", tv.sell.title), sellAccent: pick("sell_accent", tv.sell.accent), sellSub: pick("sell_sub", tv.sell.sub),
  };
};
